import React from 'react'
import PropTypes from 'prop-types'

import { Hide } from '../Hide'
import { SectionBlock } from '../SectionBlock/SectionBlock'
import { Contacts } from '../Contacts/Contacts'

import './ContactSection.css'

const ContactSection = ({ contacts, title, dark = false }) => (
    <Hide ifEmpty={contacts}>
        <SectionBlock withContainer>
            <Contacts contactList={contacts} title={title} dark={dark} />
        </SectionBlock>
    </Hide>
)

ContactSection.propTypes = {
    contacts: PropTypes.array,
    title: PropTypes.string
}

export { ContactSection }
